import React from "react"
import PropTypes from 'prop-types'
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap"
import LoaderButton from "./shared/LoaderButton"
import styled from 'styled-components'

const Panel = styled.div`
  @media all and (min-width: 480px) {
    padding: 60px 0;
    > form {
      margin: 0 auto;
      max-width: 360px;
    }
  }
`

function ForgotPasswordPanel({ email, handleChange, handleSubmit, handleCode, validatePanelEmail, validatePanelCode, validatePassword, validatePasswordEquals, isLoading, isCodeSent, code, newPassword, newPasswordRepeat }) {
  return (
    // isCodeSent ?
    <Panel>
      <form onSubmit={handleSubmit}>
        <FormGroup controlId="email" bsSize="large">
          <ControlLabel>Email para recuperação de senha</ControlLabel>
          <FormControl
            autoFocus
            type="email"
            value={email}
            onChange={handleChange}
            disabled={isCodeSent}
          />
        </FormGroup>
        <FormGroup controlId="code" bsSize="large">
          <ControlLabel>Código recebido por email</ControlLabel>
          <FormControl
            type="password"
            value={code}
            onChange={handleChange}
          />
        </FormGroup>
        <LoaderButton
          block
          bsSize="large"
          disabled={!validatePanelEmail()}
          type="button"
          isLoading={isLoading}
          text="Receber código por email"
          loadingText="Enviando email…"
          onClick={handleCode}
        />
        
        {validatePanelCode() && (
          <Panel>
            <FormGroup controlId="newPassword" bsSize="large">
              <ControlLabel>Nova senha</ControlLabel>
              <FormControl
                type="password"
                value={newPassword}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup controlId="newPasswordRepeat" bsSize="large">
              <ControlLabel>Repita Nova senha</ControlLabel>
              <FormControl
                type="password"
                value={newPasswordRepeat}
                onChange={handleChange}
              />
            </FormGroup>            
            <LoaderButton
              style={ (validatePassword() && validatePasswordEquals()) ? { backgroundColor: '#e7ffe3' } : { backgroundColor: '' }}
              block
              bsSize="large"
              disabled={!(validatePassword() && validatePasswordEquals())}
              type="submit"
              isLoading={isLoading}
              text="Alterar"
              loadingText="Alterando senha…"
            /> 
            <div>Sua senha deve conter no mínimo 8 caracteres</div>
            <div>Destes caracteres, precisam ser incluídos:</div>
            <div>Pelo menos 4 números</div>
            <div>3 letras, incluindo pelo menos uma maiúscula</div>
            <div>Um caractere especial que pode ser: !, @, #, $</div>
          </Panel>
        )}
      
      </form>
    </Panel>    
    // :
    // <Panel>
    //   <form onSubmit={handleSubmit}>
    //     <FormGroup controlId="email" bsSize="large">
    //       <ControlLabel>Email para recuperação de senha</ControlLabel>
    //       <FormControl
    //         autoFocus
    //         type="email"
    //         value={email}
    //         onChange={handleChange}
    //         disabled={isCodeSent}
    //       />
    //     </FormGroup>
    //     <LoaderButton
    //       block
    //       bsSize="large"
    //       disabled={!validateForm()}
    //       type="submit"
    //       isLoading={isLoading}
    //       text="Receber código por email"
    //       loadingText="Enviando email…"
    //     />
    //   </form>
    // </Panel>
  )
}

ForgotPasswordPanel.propTypes = {
  email: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  newPassword: PropTypes.string.isRequired,
  newPasswordRepeat: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  validatePanelEmail: PropTypes.func.isRequired,
  validatePanelCode: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
}

export default ForgotPasswordPanel
